<ng-template vdrDialogTitle>{{ "common." + mode | translate }}</ng-template>

<form [formGroup]="conditionForm" (ngSubmit)="onSubmit()">
  <div class="form-grid">
    <vdr-form-field [label]="'common.minQuantity' | translate">
      <input id="minQuantity" type="number" formControlName="minQuantity" />
    </vdr-form-field>
    <vdr-form-field [label]="'common.giftQuantity' | translate">
      <input id="giftQuantity" type="number" formControlName="giftQuantity" />
    </vdr-form-field>
  </div>
  <div style="margin-top: 15px">
    <div
      class="mb-1"
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      "
    >
      {{ "common.giftName" | translate }}
      <create-gift
        [productRetailer]="productRetailer"
        [productArtist]="productArtist"
        [productName]="productName"
        [detailForm]="detailForm"
        (refetch)="addFreeGiftCreated($event)"
      />
    </div>
    <gift-selector
      (productSelected)="productSelected($event)"
      [productRetailer]="productRetailer"
      [productArtist]="productArtist"
      [selected]="selected"
    />
    <ng-template
      ngFor
      let-variant
      [ngForOf]="variants"
      let-i="index"
      [ngForTrackBy]="trackVari"
    >
      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          border: 1px solid grey;
          border-radius: 5px;
          margin-top: 10px;
          padding: 5px;
        "
      >
        <img
          *ngIf="variant.product.featuredAsset; else imagePlaceholder"
          [src]="variant.product.featuredAsset.preview"
          style="width: 50px; height: 50px; margin-right: 10px"
        />
        <ng-template #imagePlaceholder>
          <div style="display: inline-block">
            <clr-icon shape="image" size="48"></clr-icon>
          </div>
        </ng-template>
        <div style="flex: 1">
          {{ variant.name }}
        </div>

        <clr-icon
          (click)="removeVariant(i)"
          shape="trash"
          class="is-error"
          size="16"
        ></clr-icon>
      </div>
    </ng-template>
  </div>

  <ng-template vdrDialogButtons>
    <ng-container *ngFor="let button of buttons">
      <button
        class="button ml-2"
        [class.primary]="button.type === 'primary'"
        [class.danger]="button.type === 'danger'"
        (click)="button.click()"
      >
        {{ button.label | translate : button.translationVars || {} }}
      </button>
    </ng-container>
  </ng-template>
</form>
